import InlineTextInput from '@/components/ui/inline-text-input';
import { HOTKEYS } from '@/lib/hotkeys';
import { SearchIcon, X } from 'lucide-react';
import { useFindInViewFilterContext } from './find-in-view-filter-provider';

const FindInViewFilter = () => {
  const {
    findInViewQuery,
    setFindInViewQuery,
    showFindInView,
    setShowFindInView,
  } = useFindInViewFilterContext();

  const onClose = () => {
    setFindInViewQuery('');
    setShowFindInView(false);
  };

  if (!showFindInView) return null;

  return (
    <InlineTextInput
      placeholder="Find in view..."
      value={findInViewQuery}
      onChange={(e) => setFindInViewQuery(e.target.value)}
      startAdornment={<SearchIcon className="size-4" />}
      autoFocus
      onKeyDown={(e) => {
        if (e.key === HOTKEYS.GLOBAL_UNFOCUS_OR_CLOSE) {
          onClose();
        }
      }}
      endAdornment={<X className="size-3 cursor-pointer" onClick={onClose} />}
    />
  );
};

export default FindInViewFilter;
